














import 'vue2-timepicker/dist/VueTimepicker.css'
import { defineComponent, computed } from '@vue/composition-api'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'

import { VALID_DAYS } from '../../utils/constants'

type Props = {
  placeholder: string
  format: string
  dateTime: Date | null
  importedAt: Date | undefined
}

export default defineComponent({
  name: 'TimePicker',
  components: { VueTimepicker },
  props: {
    placeholder: {
      type: String,
      default: '時:分',
    },
    format: {
      type: String,
      default: 'HH:mm',
    },
    dateTime: {
      type: Date,
      default: moment()
        .startOf('hours')
        .startOf('minutes')
        .toDate(),
    },
    importedAt: {
      type: String,
      default: null,
    },
  },
  setup(props: Props, context) {
    const value = computed<string>(() => {
      if (props.dateTime === null) {
        return ''
      }
      return moment(props.dateTime).format('HH:mm')
    })

    const onKeyup = (e: any) => {
      if (e.isComposing) {
        return true
      }
      e.target.value = `${e.target.value
        .replace(/：/g, ':')
        .replace(/[０-９]/g, (s: string) => {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
        .replace(/^[:\D]/g, '')}`
    }

    const onBlur = (e: any) => {
      if (
        !e.target.value.match(/^\d\d:\d\d$/) &&
        !e.target.value.match(/^\d{4}$/)
      ) {
        e.target.value = ''
        return
      }
      if (e.target.value.indexOf(':') === -1) {
        e.target.value = `${e.target.value.slice(0, 2)}:${e.target.value.slice(
          2,
          4,
        )}`
      }
      const hour = Number(e.target.value.split(':')[0])
      const min = Number(e.target.value.split(':')[1])
      if (isNaN(hour) || isNaN(min)) {
        e.target.value = ''
        return
      }
      if (hour < 0 || 23 < hour) {
        e.target.value = ''
        return
      }
      if (min < 0 || 59 < min) {
        e.target.value = ''
        return
      }
      if (props.dateTime === null) {
        return
      }
      const newDateTimeMoment = moment(props.dateTime)
        .hour(hour)
        .minute(min)
        .startOf('minute')
      const today = moment().startOf('minute')
      if (newDateTimeMoment.isAfter(today)) {
        // 未来のレシート日時を指定
        e.target.value = ''
        return
      }
      if (props.importedAt) {
        const importedMoment = moment(props.importedAt)
        if (importedMoment.diff(newDateTimeMoment, 'day') > VALID_DAYS) {
          // レシート日時 ~ 受取日 が5日以上経過
          e.target.value = ''
          return
        }
      }
      context.emit('update-date-time', newDateTimeMoment.toDate())
    }

    return {
      value,
      onKeyup,
      onBlur,
    }
  },
})
